import { render, staticRenderFns } from "./ReportTotaleDirezione.vue?vue&type=template&id=ed052ce0"
import script from "./ReportTotaleDirezione.vue?vue&type=script&lang=js"
export * from "./ReportTotaleDirezione.vue?vue&type=script&lang=js"
import style0 from "./ReportTotaleDirezione.vue?vue&type=style&index=0&id=ed052ce0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports